(function () {
  'use strict';

  /* @ngdoc object
   * @name dutySheet
   * @description
   *
   */
  angular
    .module('stationFlightHandling', [
      'ui.router'
    ]);
}());
